export default "__VITE_ASSET__34dd0b6f__"